export const formatDate = (date: Date): string => {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
};

export const formatDateRange = (from: Date, to: Date): string => {
    return `${formatDate(from)} - ${formatDate(to)}`;
};

export const getRemainingStatusLabel = (status: 'normal' | 'low_stock' | 'out_of_stock'): string => {
    switch (status) {
        case 'out_of_stock':
            return 'Out of Stock';
        case 'low_stock':
            return 'Low Stock';
        default:
            return '';
    }
};

export const getStatusLabel = (status: 'active' | 'inactive' | 'low_stock' | 'out_of_stock'): string => {
    switch (status) {
        case 'active':
            return 'Active';
        case 'inactive':
            return 'Inactive';
        case 'low_stock':
            return 'Low Stock';
        case 'out_of_stock':
            return 'Out of Stock';
        default:
            return '';
    }
};

export const getRemainingStatusColor = (status: 'normal' | 'low_stock' | 'out_of_stock'): string => {
    switch (status) {
        case 'out_of_stock':
            return '#dc2626'; // red
        case 'low_stock':
            return '#ea580c'; // orange
        default:
            return '#020817'; // dark
    }
};

export const getRemainingStatusBgColor = (status: 'normal' | 'low_stock' | 'out_of_stock'): string => {
    switch (status) {
        case 'out_of_stock':
            return '#fcf2f2'; // light red
        case 'low_stock':
            return '#fef3c7'; // light yellow
        default:
            return 'transparent';
    }
};

export const needsRestock = (remaining: number): boolean => (
    Number.isFinite(remaining) && remaining >= 0 && remaining <= 1
);

export const getStatusColor = (status: 'active' | 'inactive' | 'low_stock' | 'out_of_stock'): string => {
    switch (status) {
        case 'active':
            return '#016630'; // green
        case 'inactive':
            return '#64748b'; // gray
        case 'low_stock':
            return '#ea580c'; // orange
        case 'out_of_stock':
            return '#dc2626'; // red
        default:
            return '#64748b';
    }
};

export const getStatusBgColor = (status: 'active' | 'inactive' | 'low_stock' | 'out_of_stock'): string => {
    switch (status) {
        case 'active':
            return '#e2fbe8'; // light green
        case 'inactive':
            return '#f1f5f9'; // light gray
        case 'low_stock':
            return '#fef3c7'; // light yellow
        case 'out_of_stock':
            return '#fcf2f2'; // light red
        default:
            return '#f1f5f9';
    }
};
